import React from 'react'
import Engineering from './Engineering/Engineering'
import Smart from './Smart/Smart'
import Complete from './Complete/Complete'
import Header from '../../Modules/Header/Header'

const MainPage = () => {
  return (
    <div>
      <Header />
      <Engineering />
      <Smart />
      <Complete />
    </div>
  )
}

export default MainPage
